<script setup>
import RoundText from "@/components/home/RoundText.vue";
import HomeNav from "@/components/home/HomeNav.vue";
</script>
<template>
    <HomeNav/>
    <div class="home">
    <div class="try">
      <div class="text " >
        <RoundText>Hi, I am Omar</RoundText>
        <div class="flex gap-[30rem] items-center justify-center mt-4 text-white text-7xl ">
          <div>
            <h1 class="asimovian-regular">Welcome to</h1>
          </div>
          <div>
            <h1>my Portfolio</h1>
          </div>
        </div>
      </div>
      <img src="@/assets/me.svg" alt="My image" />
    </div>
  </div>
</template>
<style scoped>

.home {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
    background-image: url('@/assets/bg.png');
  background-size: contain;
}

.try {
  background: #2e2e2e;
  width: 80vw;
  height: 80vh;
  border-radius: 50%;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.try img {
  width: 30rem;
  position: absolute;
  left: 50%;
  bottom: -25%;
  transform: translate(-50%, 0);
}
.try .text * {
  font-family: "Asimovian", sans-serif;
  font-weight: 400;
  font-style: normal;
}
@media (max-width: 1638px) {
    .try .text .flex h1{
        font-size: 3rem;
    }    

}
@media (max-width: 1300px) {
    .try .text .flex h1{
        font-size: 2rem;
    }    
}
@media (max-width: 1100px) {
    .try .text .flex h1{
        font-size: 1.5rem;
    }    
}
@media (max-width: 1050px) {
  .try {
    width: 100vw;
    height: 80vh;
    border-radius: 30rem 30rem 0 0;
  }
  .home{
    align-items: end;
  }
      .try .text .flex h1{
        font-size: 3rem;
    }       
    .try .text .flex {
        gap: 35vw;
    }   
}
@media (max-width: 875px) {

      .try .text .flex h1{
        font-size: 2rem;
    }       
    .try .text .flex {
        gap: 45vw;
    }   
}
@media (max-width: 750px) {

    .try .text .flex h1{
        font-size: 1.5rem;
    }       
    .try .text .flex {
        position: absolute;
        top:40%;
        left:50%;
        transform: translate(-50%, -50%);
        gap: 0.5rem;
        width: 100vw;
    }   
    .try img {
        width: 20rem;
        bottom: -20%;
    }
}
</style>
